import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// layouts
import { AdminComponent } from "../../layouts/admin/admin.component";

// admin views
import { DashboardComponent } from "./dashboard/dashboard.component";
import { MapsComponent } from "./maps/maps.component";
import { SettingsComponent } from "./settings/settings.component";
import { TablesComponent } from "./tables/tables.component";
import { AccountInfoComponent } from "./account-info/account-info.component";
import { AppointmentListComponent } from "./appointment-list/appointment-list.component";
import { UserWalletComponent } from "./user-wallet/user-wallet.component";
import { MessageComponent } from "./message/message.component";
import { ChatComponent } from "./chat/chat.component";
import { PatientProfileComponent } from "./patient-profile/patient-profile.component";
import { DoctorCalendarComponent } from "./doctor-calendar/doctor-calendar.component";
import { VisitLinkComponent } from "../visit/visit-link/visit-link.component";

export const UserLayoutRoutes: Routes = [
      // { path: "", component: DashboardComponent },
      { path: "dashboard", component: DashboardComponent },
      { path: "settings", component: SettingsComponent },
      { path: "tables", component: TablesComponent },
      { path: "maps", component: MapsComponent },
      { path: "account", component: AccountInfoComponent},
      { path: "appointment", component: AppointmentListComponent},
      { path: "wallet", component: UserWalletComponent},
      { path: "message", component: MessageComponent},
      { path: "chat/:visitId", component: ChatComponent},
      { path: "patient-info", component: PatientProfileComponent},
      { path: "doctor-calendar", component: DoctorCalendarComponent},
      { path: "visit-link/:visitId", component: VisitLinkComponent},

    //   { path: "", redirectTo: "dashboard", pathMatch: "full" },
];
